let events = {};

const _emit = function(name, ...args) {
    if(events.hasOwnProperty(name)) {
        const subscribers = events[name] || [];
        let newSubscriber = [];
        for(let i = 0, len = subscribers.length; i < len; i++) {
            // если функция возвращает минус 1, мы удаляем сабскрайбера
            if(subscribers[i][0].apply(subscribers[i][1] || null, args) !== -1 && subscribers[i][2] !== true) {
                newSubscriber.push(subscribers[i]);
            }
        }

        // перезаписываем сабскраберов
        if(newSubscriber.length) {
            events[name] = newSubscriber;
        }
        else {
            events[name] = undefined;
            delete events[name];
        }
    }
};

const __subscribe = function(name, cb, context = undefined, isOne = false) {
    if(typeof(cb) == 'function') {
        name = (typeof(name) == 'object' && name instanceof Array) ? name : [name];

        for(let i = 0, len = name.length; i < len; i++)
        {
            events[name[i]] = events[name[i]] || [];
            events[name[i]].push([cb, context, isOne]);
        }
    }
};

const _subscribe = function(name, cb, context = undefined) {
    __subscribe(name, cb, context, false);
};

const _one = function(name, cb, context = undefined) {
    __subscribe(name, cb, context, true)
};

const _subscribeWithReplace = function(name, cb, context = undefined, isOne = false) {
    if(typeof(cb) == 'function') {
        if(name in events) {
            let isReplaced = false;
            let _newEvents = [];
            for(let i = 0, len = events[name].length; i < len; i++) {
                if(events[name][i][0] === cb) {
                    _newEvents.push([cb, context, isOne]);
                    isReplaced = true;
                }
                else {
                    _newEvents.push(events[name][i]);
                }
            }

            if(!isReplaced) {
                _newEvents.push([cb, context, isOne]);
            }
            events[name] = _newEvents;
        }
        else {
            events[name] = [[cb, context, isOne]];
        }
    }
};

const _unsubscribe = function(name, cb) {
    name = (typeof(name) === 'object' && name instanceof Array ? name : [name]);

    for (let i = 0, len = name.length; i < len; i++) {
        if (events.hasOwnProperty(name[i])) {
            let subscribers = events[name[i]];

            if (typeof(cb) === 'function' && subscribers.length) {
                let newSubscribers = [];

                for (let j = 0, len2 = subscribers.length; j < len2; j++) {
                    if (subscribers[j][0] !== cb) {
                        newSubscribers.push(subscribers[j]);
                    }
                }

                events[name[i]] = newSubscribers;
            }
            else {
                events[name[i]] = [];
            }
        }
    }
};

export default {
    emit: _emit,
    on: _subscribe,
    one: _one,
    onReplace: _subscribeWithReplace,
    off: _unsubscribe
};